import React from 'react'
import { Columns, Column } from '@oldscope/ui/components/Columns'
import { get, compact } from 'lodash'
import { compareAsc, subWeeks } from 'date-fns'
import styled from 'styled-components'

import Header from '@oldscope/ui/components/Header'
import Link from './Link'
import { ContentfulQuery } from './ContentfulDataProvider'

const MyLink = styled(Link)`
  text-decoration: none !important;
`
const MyHeader = styled(Header)`
  margin-top: 10px !important;
`

export default () => (
  <ContentfulQuery
    single
    query={{
      content_type: 'collection',
      'fields.name': 'Featured',
      select: 'fields.items',
    }}
  >
    {({ items }) => (
      <Columns>
        {compact(
          items
            .slice(0, 5)
            .map(
              (
                {
                  sys,
                  fields: {
                    image,
                    featuredImage,
                    previewImage,
                    title,
                    slug,
                    externalURL,
                    link,
                    startDateTime,
                  },
                },
                i,
              ) => {
                if (
                  startDateTime &&
                  compareAsc(startDateTime, subWeeks(new Date(), 1)) === -1
                )
                  return null
                const type = get(sys, 'contentType.sys.id')
                const href =
                  externalURL ||
                  link ||
                  (type === 'page' ? `/${slug}` : `/${type}/${slug}`)

                return (
                  <Column key={i}>
                    <MyLink href={href}>
                      <img
                        alt={title}
                        style={{ width: '100%' }}
                        src={`${get(
                          previewImage || featuredImage || image,
                          'fields.file.url',
                        )}?fit=thumb&w=450&h=350`}
                      />
                      <MyHeader importance={5}>{title}</MyHeader>
                    </MyLink>
                  </Column>
                )
              },
            ),
        )}
      </Columns>
    )}
  </ContentfulQuery>
)
